import { Counterparties, Props } from '@/components/Counterparties';
import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { ApPayeeForm } from '@/features/ap_payees/components/AddNewPayeeDialog';
import { useTranslation } from '@/i18n';
import {
  ButtonV2,
  IconAdd,
  Label,
  ListView,
  Single,
} from '@moneyforward/ap-frontend-components';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../index.module.scss';

const cx = classnames.bind(styles);

export type TRelateCounterpartyProps = {
  control: Control<ApPayeeForm>;
  onCounterpartyModalOpen: () => void;
  defaultOptions?: Props<ApPayeeForm>['defaultOptions'];
  counterpartyOpen: boolean;
};

export const RelateCounterparty: FC<TRelateCounterpartyProps> = memo(
  ({ control, onCounterpartyModalOpen, defaultOptions, counterpartyOpen }) => {
    const { t } = useTranslation();
    const selectRules = useMemo(() => ({}), []);
    const context = useFFContext();

    return (
      <Wrapper isProto={false}>
        <OpenFeatureProvider
          pollInterval={-1}
          context={context}
          domain='ap-counterparty-uniqueness-removal'
        >
          <div className={cx(styles['section-wrap'])}>
            <div className={cx(styles['section-title-button-wrap'])}>
              <div className={cx(styles['section-title'])}>
                {t('relate_counterparty_title')}
              </div>
            </div>
            <ListView>
              <Single>
                <Label
                  required
                  text={t('ap_payee_counterparty_account')}
                  htmlFor='ap_counterparty_id'
                />
                <Counterparties<ApPayeeForm>
                  // Key: To reset a search query in Dropdown of Counterparties(Keeping the query make the dropdown show encrypted id when adding a new counterparty)
                  key={`ap_counterparty_combobox_${counterpartyOpen}`}
                  control={control}
                  name='ap_counterparty_id'
                  inputId='ap_counterparty_id'
                  testId='ap_counterparty_id'
                  selectProps={selectRules}
                  defaultOptions={defaultOptions}
                />
              </Single>
            </ListView>

            <div className={cx(styles['text-link-wrap-secondary'])}>
              {t('relate_counterparty_info_text')}
              <ButtonV2
                leftIcon={<IconAdd size={0} />}
                onClick={onCounterpartyModalOpen}
                size='sm'
                color='primary'
                isTransparent
              >
                {t('add_new_counterparty_button')}
              </ButtonV2>
            </div>
          </div>
        </OpenFeatureProvider>
      </Wrapper>
    );
  }
);

RelateCounterparty.displayName = 'RelateCounterparty';
